import {useState} from "react";
import * as React from "react";
import {Button, LinearProgress, Link as MuiLink, TextField} from "@mui/material";

import {Link, useNavigate} from "react-router-dom";
import {useSnackbar} from 'notistack';
import {resetPassword} from "../../utils/Api";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import FormWrapper from "../../components/PaperFormWrapper/PaperFormWrapper";

export const ResetPasswordContainer = () => {
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar();
    const [token, setToken] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");

    const [loading, setLoading] = useState(false);

    // Notification helper - pops up error message
    const toastHelper = (msg, type) => {
        enqueueSnackbar(msg, {
            preventDuplicate: true,
            variant: type,
            anchorOrigin: {horizontal: 'right', vertical: 'bottom'}
        });
    }


    // Handlers
    const handleTokenInput = (event) => {
        setToken(event.target.value);
    };

    const handlePasswordInput = (event) => {
        setPassword(event.target.value);
    };

    const handlePasswordConfirmInput = (event) => {
        setPasswordConfirm(event.target.value);
    };

    const handleReset = async (event) => {
        event.preventDefault();
        if (password !== passwordConfirm) {
            toastHelper("New password and confirm password were not the same! Please re-input desired password.", "error");
        } else if (!token || token.trim().length < 1) {
            toastHelper("Please enter the code provided to you via email.", "error");
        } else {
            setLoading(true);
            const response = resetPassword({
                "password": password,
                "token": token
            });
            response.then(resolution => {
                toastHelper("Password changed successfully!", "success");
                navigate('/login');
            }).catch(error => {
                console.error(error)
                const errorText = error.response.data[Object.keys(error.response.data)[0]];
                toastHelper("Error: " + errorText, "error");
            }).finally(() => setLoading(false));
        }
    };

    // React Fragment:
    return (
        <FormWrapper title="Reset Password" titleLinkTo={"/login"} titleLinkLabel="Back to Login" loading={loading}
                     onSubmit={handleReset}>
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                id="recoveryCode"
                label="Recovery Code"
                name="recoveryCode"
                onChange={handleTokenInput}
            />

            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="password"
                label="New Password (8 characters min.)"
                type="password"
                id="password"
                onChange={handlePasswordInput}
            />

            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                onChange={handlePasswordConfirmInput}
            />


            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{mt: 3}}
                disabled={loading}
            >
                Reset Password
            </Button>
        </FormWrapper>
    )
        ;
};

